import { combineReducers } from 'redux'

import {
  MASTER_GET_DETAIL_CAT_SHIFT,
  MASTER_GET_DETAIL_CAT_SHIFT_FAILED,
  MASTER_GET_DETAIL_CAT_SHIFT_RESET,
  MASTER_GET_DETAIL_CAT_SHIFT_SUCCESS,
  MASTER_GET_LIST_CAT_SHIFT,
  MASTER_GET_LIST_CAT_SHIFT_FAILED,
  MASTER_GET_LIST_CAT_SHIFT_RESET,
  MASTER_GET_LIST_CAT_SHIFT_SUCCESS,
  MASTER_SYNC_CAT_SHIFT,
  MASTER_SYNC_CAT_SHIFT_FAILED,
  MASTER_SYNC_CAT_SHIFT_RESET,
  MASTER_SYNC_CAT_SHIFT_SUCCESS,
} from '../actions/cat-shift'

/**
 * Sample reducer
 * @param {object} state
 * @param {object} action
 * @returns
 */
function listCatShift(
  state = {
    isLoading: false,
    data: [],
  },
  action,
) {
  switch (action.type) {
    case MASTER_GET_LIST_CAT_SHIFT:
      return { ...state, isLoading: true }
    case MASTER_GET_LIST_CAT_SHIFT_SUCCESS:
      const { data, total } = action.payload
      return {
        ...state,
        isLoading: false,
        data,
        total,
      }
    case MASTER_GET_LIST_CAT_SHIFT_FAILED:
      return {
        ...state,
        isLoading: false,
      }
    case MASTER_GET_LIST_CAT_SHIFT_RESET:
      return {
        isLoading: false,
        data: [],
      }
    default:
      return state
  }
}

function detailCatShift(state = { isLoading: false, data: {} }, action) {
  switch (action.type) {
    case MASTER_GET_DETAIL_CAT_SHIFT:
      return {
        ...state,
        isLoading: true,
      }
    case MASTER_GET_DETAIL_CAT_SHIFT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: action.payload,
      }
    case MASTER_GET_DETAIL_CAT_SHIFT_FAILED:
      return {
        ...state,
        isLoading: false,
      }
    case MASTER_GET_DETAIL_CAT_SHIFT_RESET:
      return { isLoading: false, data: {} }
    default:
      return {
        ...state,
      }
  }
}

function syncCatShift(
  state = {
    isLoading: false,
    data: [],
  },
  action,
) {
  switch (action.type) {
    case MASTER_SYNC_CAT_SHIFT:
      return { ...state, isLoading: true }
    case MASTER_SYNC_CAT_SHIFT_SUCCESS:
      const { data, total } = action.payload
      return {
        ...state,
        isLoading: false,
        data,
        total,
      }
    case MASTER_SYNC_CAT_SHIFT_FAILED:
      return {
        ...state,
        isLoading: false,
      }
    case MASTER_SYNC_CAT_SHIFT_RESET:
      return {
        isLoading: false,
        data: [],
      }
    default:
      return state
  }
}

export default combineReducers({
  listCatShift,
  detailCatShift,
  syncCatShift,
})
